/**
 * ინტერაქცია — გარე კომუნიკაციის ერთი ადგილი.
 *
 * მეილი და SMS ერთსა და იმავე მოვლენებს ემსახურება (პაროლის აღდგენა,
 * გაცდენა), ამიტომ ორ ცალკე გვერდად გაშლა ადმინს აიძულებდა, ერთი და იმავე
 * კითხვაზე პასუხი ორგან ეძებნა.
 */

import { useState } from 'react';
import { Mail, MessageSquare } from 'lucide-react';
import clsx from 'clsx';
import { PageHeader } from '../../components/ui';
import { EmailFlowsPanel } from './EmailFlowsPage';
import { SmsFlowsPanel } from './SmsFlowsPanel';

type Channel = 'email' | 'sms';

const TABS: { key: Channel; label: string; icon: typeof Mail }[] = [
  { key: 'email', label: 'მეილის ნაკადები', icon: Mail },
  { key: 'sms', label: 'SMS ნაკადები', icon: MessageSquare },
];

export function InteractionsPage() {
  const [channel, setChannel] = useState<Channel>('email');

  return (
    <>
      <PageHeader
        title="ინტერაქცია"
        subtitle="რომელი მოვლენა რომელი არხით მიდის სტუდენტთან და თანამშრომელთან"
      />

      <div className="mb-6 flex gap-1 border-b border-line">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setChannel(key)}
            className={clsx(
              '-mb-px flex items-center gap-2 border-b-2 px-4 py-2.5 text-[13px] font-medium transition',
              channel === key
                ? 'border-brand-600 text-brand-700'
                : 'border-transparent text-ink-mute hover:text-ink',
            )}
          >
            <Icon className="size-4" />
            {label}
          </button>
        ))}
      </div>

      {channel === 'email' ? <EmailFlowsPanel /> : <SmsFlowsPanel />}
    </>
  );
}
